/**
 * Business profiles (Settings → Business type). A profile decides which stock
 * product types, categories and technical fields the app offers, so an
 * electrician never sees mould cavities and a machinery seller gets them.
 * Keep the keys in sync with BUSINESS_TYPES in backend/src/routes/settings.js.
 */

const GENERAL_SPEC_FIELDS = ['voltage', 'power', 'material', 'size', 'weight', 'color'];

export const BUSINESS_PROFILES = {
    GENERAL: {
        label: 'General business',
        description: 'Products and services of any kind.',
        productTypes: ['GENERAL'],
        categories: ['Electrical', 'Plumbing', 'HVAC', 'Tools', 'Hardware', 'Lighting', 'Other'],
        specFields: GENERAL_SPEC_FIELDS,
    },
    ELECTRICAL: {
        label: 'Electrical & technical contractor',
        description: 'Electricians, HVAC, plumbing and installation work.',
        productTypes: ['GENERAL'],
        categories: ['Cables & wires', 'Breakers & panels', 'Lighting', 'Switches & sockets', 'HVAC', 'Plumbing', 'Tools', 'Other'],
        specFields: GENERAL_SPEC_FIELDS,
    },
    PLASTIC_MACHINERY: {
        label: 'Plastic machinery sales & maintenance',
        description: 'Machines, moulds, accessories and spare parts.',
        productTypes: ['GENERAL', 'MACHINE', 'MOULD', 'ACCESSORY'],
        generalLabel: 'Spare part',
        categories: ['Spare parts', 'Heaters & thermocouples', 'Hydraulics', 'Electrical', 'Screws & barrels', 'Other'],
        specFields: ['material', 'size', 'weight', 'color'],
    },
};

export const BUSINESS_TYPES = Object.keys(BUSINESS_PROFILES);

export const getBusinessProfile = (businessType) => BUSINESS_PROFILES[businessType] || BUSINESS_PROFILES.GENERAL;
